import { ArrowRight, LockKeyhole } from "lucide-react";

interface LoginPageProps {
  error: string | null;
  loading: boolean;
  onSignIn: () => void;
}

export function LoginPage({ error, loading, onSignIn }: LoginPageProps) {
  const invited = new URLSearchParams(window.location.search).has("invite");
  return (
    <main className="login-layout">
      <section className="login-form-panel" aria-label="Sign in">
        <div className="login-card">
          <div className="brand-lockup login-brand">
            <span className="brand-mark" aria-hidden="true">O</span>
            <span>OTTAGIVE</span>
          </div>
          <h1>{invited ? "Create card templates" : "Authorized access only"}</h1>
          <p className="muted">{invited ? "Use the Google account matching your invitation email. Your template access is set up automatically when you sign in." : "Sign in with an approved account."}</p>
          {error ? <div className="form-error" role="alert">{error}</div> : null}
          <button className="primary-button login-button" onClick={onSignIn} disabled={loading}>
            <LockKeyhole size={18} aria-hidden="true" />
            {loading ? "Verifying access…" : "Continue with Google"}
            <ArrowRight size={18} aria-hidden="true" />
          </button>
          <p className="security-note">Access attempts are monitored.</p>
        </div>
      </section>
    </main>
  );
}
